import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import BackToTop from "@/components/base/BackToTop";

export default function Layout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Outlet />
      <Footer />
      <BackToTop />
    </>
  );
}